<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} ALARMAS</h1>
    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel
            label="ALARMAS"
            width="100%"
            height="100%"
            :size="4"
            color="cyan"
            border="solid 6px yellow"
          >
          </HmiLabel>
        </div>
        <div class="grid">
          <div class="alarms">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-heading" colspan="1" width="1px">*</th>
                    <th class="text-heading" colspan="1">HORA ACTIV. ALARMA</th>
                    <th class="text-heading" colspan="1">HORA DESAC. ALARMA</th>
                    <th class="text-heading" colspan="1">MENSAJE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(alarma, index) in alarmas" :key="index">
                    <td
                      :class="{
                        'bg-rojo': alarma.estado === 'AN',
                        'bg-rosa': alarma.estado === 'AC',
                        'bg-azul': alarma.estado === 'CN',
                        'bg-verde': alarma.estado === 'CC',
                      }"
                    ></td>
                    <td>{{ alarma.fechaActiv }}</td>
                    <td>{{ alarma.fechaDesac }}</td>
                    <td>{{ alarma.mensaje }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div class="custom-row">
            <HmiLabel
              label="HORA ACTIV. ALARMA"
              width="25%"
              height="80%"
              :size="1.7"
              color="cyan"
            ></HmiLabel>
            <HmiLabel
              label="HORA DESAC. ALARMA"
              width="25%"
              height="80%"
              :size="1.7"
              color="cyan"
            ></HmiLabel>
            <HmiButton
              label="HISTORICOS"
              width="25%"
              height="80%"
              :size="1.7"
              color="silver"
            ></HmiButton>
            <HmiButton
              label="SALIR"
              width="25%"
              height="80%"
              :size="1.7"
              color="silver"
              @click.native="navigateToMenu"
            ></HmiButton>
          </div>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiButton from "../HMI/HmiButton.vue";
import HmiLabel from "../HMI/HmiLabel.vue";
import HmiPantalla from "../HMI/HmiPantalla.vue";
export default {
  name: "AlarmasPantalla",
  components: {
    HmiButton,
    HmiLabel,
    HmiPantalla,
  },
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },
  },
  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },
  },
  data() {
    return {
      alarmas: [
        {
          estado: "AN",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
        {
          estado: "AC",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
        {
          estado: "CC",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
        {
          estado: "CN",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
        {
          estado: "CN",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
        {
          estado: "CN",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
        {
          estado: "CC",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
        {
          estado: "CN",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
        {
          estado: "AC",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
        {
          estado: "AN",
          fechaActiv: "27/09/23 9:28",
          fechaDesac: "27/09/23 9:28",
          mensaje: "Mensaje de alarma",
        },
      ],
    };
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  height: 15%;
}

.grid {
  height: 85%;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  gap: 20px;
}

.custom-row {
  display: flex;
  gap: 20px;
  width: 100%;
  height: 15%;
}

.alarms {
  height: 85%;
  overflow-y: scroll;
}

.bg-rojo {
  background-color: #ff0000;
}

.bg-rosa {
  background-color: #ff00ff;
}

.bg-azul {
  background-color: #0000ff;
}

.bg-verde {
  background-color: #00ff00;
}

tr:hover {
  background: #ffff00 !important;
}

tbody {
  background-color: #ffc0ff;
}

td {
  border-left: solid 1px #0000ff;
  border-top: solid 1px #0000ff;
}

.text-heading {
  background-color: cyan;
  border-left: solid 1px;
  font-weight: bold;
}
</style>
